export enum WebEDIDocumentPropertiesKeys {
  PARTNER = 'partner',
  STATUS = 'status',
  ISSUE_RESOLVER = 'issueResolver',
  ENVIRONMENT = 'environment',
  DOCUMENT_DATE = 'documentDate',
  PROOF_OF_DELIVERY = 'proofOfDelivery',
  EDIT_INFORMATION = 'editInformation',
  DOCUMENT_SOURCE = 'documentSource',
  ORIGINAL_PDF = 'originalPDF',
}
